import React from 'react';
import s from './style.css';
const Input = ({ autoFocus, placeholder, onChange, width, value, style, password }) => {
    return (React.createElement("input", { className: s.input, style: { width, ...style }, autoFocus: autoFocus, placeholder: placeholder, onChange: onChange, value: value, type: password ? 'password' : 'text' }));
};
export default Input;
